import axios from 'axios'

export default {
  list(projectId) {
    return axios.get(`/projects/${projectId}/notifications`).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  store(projectId, data) {
    return axios.post(`/projects/${projectId}/notifications`, data).then(response => {
      return { success: true}
    }, response => {
      throw { success: false}
    })
  }
}
